<div *ngIf="id" class="form-group m-form__group m-form__group--colored m--margin-top-15 m--padding-15">
  <div *ngIf="!isLoading.list" class="m--padding-left-15 m--padding-right-15">
    <h5 class="m--margin-bottom-15">{{ 'suppliers-address.address' | transloco }}</h5>

    <div class="row m--padding-bottom-15" *ngFor="let item of list; let i = index">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <select [(ngModel)]="list[i].type" class="form-control m-input m-input--square">
          <option value="">{{ 'suppliers-address.noChoose' | transloco }}</option>
          <option *ngFor="let item of types" [value]="item">{{ 'suppliers.address.type.' + item | transloco }}</option>
        </select>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <input type="text" [(ngModel)]="list[i].city" (focusout)="updateData(item)" class="form-control m-input" [placeholder]="'suppliers-address.city' | transloco">
      </div>

      <div class="col-lg-5 col-md-5 col-sm-12">
        <div class="input-group">
          <input type="text" class="form-control m-input" [(ngModel)]="list[i].address" (focusout)="updateData(item)" [placeholder]="'suppliers-address.address' | transloco">

          <span class="input-group-btn">
            <button (click)="removeField(item, i)" class="btn btn-danger btn-thin" type="button">
              <i class="la la-trash"></i>
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="text-right">
      <button (click)="addField()" class="btn btn-success m-btn--icon" type="button">
        <span>
          <i class="la la-plus"></i>
          <span>{{ 'suppliers-address.btn.addAddress' | transloco }}</span>
        </span>
      </button>
    </div>
  </div>

  <div *ngIf="isLoading.list" class="m-page-loader m-page-loader--non-block m-page-loader--relative">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>
